import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { nav } from '../mock';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [compact, setCompact] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 40);
      setCompact(y > 90);
    };
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || open;
  const textColor = solid ? 'text-ink' : 'text-bone';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        solid ? 'bg-bone/95 backdrop-blur-sm border-b border-ink/10' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="flex items-center justify-between h-20 md:h-24">
          <Link
            to="/"
            className="relative flex items-center h-[28px] md:h-[32px] pl-1"
            aria-label="KEPP forside"
          >
            {/* Fuldt logo reserverer bredden, så der ikke sker layout-hop */}
            <img
              src="/kepp-logo.webp?v=2"
              alt="KEPP"
              className={`h-full w-auto object-contain transition-[filter,opacity] duration-500 ${
                solid ? 'brightness-0' : ''
              } ${compact ? 'opacity-0' : 'opacity-100'}`}
            />
            {/* Kompakt K overlejres i venstre kant */}
            <img
              src="/kepp-k.webp?v=2"
              alt=""
              aria-hidden="true"
              className={`absolute left-1 top-0 h-full w-auto object-contain transition-[filter,opacity] duration-500 ${
                solid ? 'brightness-0' : ''
              } ${compact ? 'opacity-100' : 'opacity-0'}`}
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-7 xl:gap-9">
            {nav.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`link-underline text-[11px] uppercase tracking-[0.18em] font-light transition-opacity hover:opacity-60 ${textColor} ${
                  location.pathname === item.path ? 'opacity-100' : 'opacity-90'
                }`}
              >
                {item.short}
              </Link>
            ))}
          </nav>

          <button
            className={`lg:hidden ${textColor}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X size={24} strokeWidth={1.2} /> : <Menu size={24} strokeWidth={1.2} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-bone border-t border-ink/10">
          <nav className="flex flex-col px-6 py-6">
            {nav.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="py-3 text-ink text-sm uppercase tracking-[0.2em] font-light border-b border-ink/5 last:border-0"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
